<i18n src="./resources/locales.json"></i18n>
<template>
  <ul class="active-business-process-container">
    <EcsBusinessProcessElement
      v-for="(item, index) in items"
      :key="`${item.label}-${index}`"
      :label="item.label"
      :value="item.value"
    />
  </ul>
</template>

<script>
import DateTime from 'luxon/src/datetime';
import EcsBusinessProcessElement from '@/components/ecs-summary-view/EcsBusinessProcessElement';

export default {
  name: '',
  props: {
    businessProcess: {
      type: Object,
      required: true
    },
    defaultFromEmail: {
      type: String,
      required: true
    },
    defaultBccEmail: {
      type: String,
      required: true
    }
  },
  components: { EcsBusinessProcessElement },
  computed: {
    items() {
      const items = [
        {
          label: 'businessProcessSummaryCard.name',
          value: this.businessProcess.name
        },
        {
          label: 'businessProcessSummaryCard.endpoint',
          value: this.businessProcess.endPoint
        },
        {
          label: 'businessProcessSummaryCard.assigned.title',
          value: [
            {
              label: 'businessProcessSummaryCard.assigned.agents',
              value: this.businessProcess.agentsAssigned.length
            },
            {
              label: 'businessProcessSummaryCard.assigned.supervisors',
              value: this.businessProcess.supervisorsAssigned.length
            }
          ]
        },
        {
          label: 'businessProcessSummaryCard.goalTime.title',
          value: [
            {
              label: 'businessProcessSummaryCard.goalTime.telephony',
              value: this.businessProcess.goalTimeTelephony
            },
            {
              label: 'businessProcessSummaryCard.goalTime.chat',
              value: this.businessProcess.goalTimeChat
            },
            {
              label: 'businessProcessSummaryCard.goalTime.sms',
              value: this.businessProcess.goalTimeSMS
            },
            {
              label: 'businessProcessSummaryCard.goalTime.email',
              value: this.businessProcess.goalTimeEmail
            }
          ]
        }
      ];

      if (this.businessProcess.outgoingCallDID) {
        items.push({
          label: 'businessProcessSummaryCard.callDid',
          value: this.businessProcess.outgoingCallDID.did
        });
      }

      if (this.businessProcess.operationalHours.length !== 0) {
        items.push({
          label: 'businessProcessSummaryCard.operationalHours.title',
          value: [
            {
              label: 'businessProcessSummaryCard.operationalHours.startTime',
              value: DateTime.fromISO(this.businessProcess.operationalHours[0].startTime).toFormat('HH:ss')
            },
            {
              label: 'businessProcessSummaryCard.operationalHours.endTime',
              value: DateTime.fromISO(this.businessProcess.operationalHours[0].endTime).toFormat('HH:ss')
            }
          ]
        });
      }

      if (this.defaultFromEmail && this.defaultFromEmail.length > 0) {
        items.push({
          label: 'businessProcessSummaryCard.defaultFromEmailAddress',
          value: this.defaultFromEmail
        });
      }

      if (this.businessProcess.alternateBPFromEmailAddressAliases.length !== 0) {
        items.push({
          label: 'businessProcessSummaryCard.alternateBPFromEmailAddressAliases',
          value: this.businessProcess.alternateBPFromEmailAddressAliases.map(email => ({
            label: 'businessProcessSummaryCard.valueOnly',
            value: email
          }))
        });
      }

      if (this.defaultBccEmail && this.defaultBccEmail.length > 0) {
        items.push({
          label: 'businessProcessSummaryCard.defaultBccEmailAddress',
          value: this.defaultBccEmail
        });
      }

      if (this.businessProcess.overrideBCCEmailAddress && this.businessProcess.overrideBCCEmailAddress.length > 0) {
        items.push({
          label: 'businessProcessSummaryCard.overrideBccEmailAddress',
          value: this.businessProcess.overrideBCCEmailAddress
        });
      }

      if (this.businessProcess.smsDIDs.length !== 0) {
        items.push({
          label: 'businessProcessSummaryCard.smsDIDs',
          value: this.businessProcess.smsDIDs.map(smsDID => {
            return {
              label: 'businessProcessSummaryCard.valueOnly',
              value: `${smsDID.did} ${smsDID.isDefault ? `${this.$t('businessProcessSummaryCard.default')}` : ''}`
            };
          })
        });
      }

      return items;
    }
  }
};
</script>

<style scoped>
.active-business-process-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
  list-style: none;
  padding-left: 0;
  grid-gap: 8px;
  max-height: 100%;
  overflow-y: auto;
}
</style>
